import { ClienteProdutoAfiliados } from '../../../../../../../types/cliente-produto';
import { simNao } from '../format';
import { CollapsibleSection } from './collapsible-section';
import { Row } from './styles';

interface Props {
  data: ClienteProdutoAfiliados;
}

export const AfiliadosSection = ({ data }: Props) => (
  <CollapsibleSection
    title="Afiliados e cupons"
    testId="produto-section-afiliados"
  >
    <Row>
      <span>Habilita afiliados</span>
      <span>{simNao(data.habilitaAfiliados)}</span>
    </Row>
    <Row>
      <span>Validação manual de afiliado</span>
      <span>{simNao(data.validarAfiliadoManualmente)}</span>
    </Row>
    <Row>
      <span>Comissão afiliado</span>
      <span>
        {data.comissaoAfiliado != null ? `${data.comissaoAfiliado}%` : '—'}
      </span>
    </Row>
    <Row>
      <span>Habilita cupom</span>
      <span>{simNao(data.habilitaCupom)}</span>
    </Row>
  </CollapsibleSection>
);
